import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  CheckListModel,
  ItemCheckListChangeModel,
  ItemCheckListModel,
} from '../../../models/check-lists/check-list-model';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {Subscription} from 'rxjs';
import {AutorisationAggregate} from '../../../aggregats/autorisation/autorisation.aggregate';
import {OperationFonction} from '../../../constantes/operations-fonctions.constantes';
import {FonctionLogicielle} from '../../../constantes/fonctions-logicielle-constantes';
import {UtilisateurCourantService} from '../../../services/utilisateurs/utilisateur-courant.service';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss'],
})
export class ChecklistComponent implements OnInit, OnDestroy {
  addNewIsVisible = false;
  enregistrementEnCours = false;
  isModeEdition = false;
  authorizedEdition = false;
  canDelete = false;
  @Output() saveItem: EventEmitter<CheckListModel> = new EventEmitter<CheckListModel>();

  private subs: Subscription[] = [];

  private _checklist: CheckListModel;

  @Input() set checklist(value: CheckListModel) {
    this.enregistrementEnCours = false;
    this._checklist = value;
  }

  @Input() set EnregistrementEffectifEnCours(value){
    this.enregistrementEnCours = value;
  }

  get checklist() {
    return this._checklist;
  }

  constructor(
    private utilisateurCourantService: UtilisateurCourantService,
  ) {}

  ngOnInit() {
    const aut = new AutorisationAggregate(FonctionLogicielle.Inscriptions, OperationFonction.Edition);
    this.subs.push(this.utilisateurCourantService.isAuthorized(aut).subscribe(res => (this.authorizedEdition = res)));
    const del = new AutorisationAggregate(FonctionLogicielle.Inscriptions, OperationFonction.Suppression);
    this.subs.push(this.utilisateurCourantService.isAuthorized(del).subscribe(res => (this.canDelete = res)));
  }

  ngOnDestroy() {
    this.subs.forEach(it => it.unsubscribe());
    this.subs = [];
  }

  switchVisibilityAddNew() {
    if (this.authorizedEdition) {
      this.addNewIsVisible = !this.addNewIsVisible;
    } else {
      this.addNewIsVisible = false;
    }
  }

  drop(event: CdkDragDrop<Array<ItemCheckListModel>>) {
    if (event.previousIndex !== event.currentIndex) {
      this.enregistrementEnCours = true;
      moveItemInArray(this.checklist.elements, event.previousIndex, event.currentIndex);
      this.saveCheckList();
    }
  }

  isDragDisabled(): boolean {
    if (this.authorizedEdition) {
      return this.isModeEdition || this.enregistrementEnCours;
    } else {
      return true;
    }
  }

  saveCheckList() {
    this.saveItem.emit(this._checklist);
  }

  setItemChanged($event: ItemCheckListChangeModel) {
    this.enregistrementEnCours = true;
    this._checklist.elements[$event.order].libelle = $event.libelle;
    this._checklist.elements[$event.order].estCoche = $event.estCoche;
    this.saveCheckList();
  }

  setItemDeleted(order: number) {
    this.enregistrementEnCours = true;
    this._checklist.elements = this._checklist.elements.filter(
      elem => this._checklist.elements.indexOf(elem) !== order,
    );
    this.saveCheckList();
  }

  getOrder(item: ItemCheckListModel) {
    return this._checklist.elements.findIndex(elem => elem.libelle == item.libelle);
  }

  setItemAdded($event: ItemCheckListModel) {
    if ($event.libelle && $event.libelle.length > 0) {
      this.enregistrementEnCours = true;
      this._checklist.elements.push($event);
      this.addNewIsVisible = false;
      this.saveCheckList();
    }
  }
}
